import { sessionStorage as ss } from '@netlify/app-auth'
import { Pane } from 'evergreen-ui'
import { useEffect, useState } from 'react'
import Draggable from 'react-draggable'

import DockMinimized from '~/components/DockMinimized'
import DockStateErrored from '~/components/DockStateErrored'
import DockStateJoinTeam from '~/components/DockStateJoinTeam'
import DockStateLoading from '~/components/DockStateLoading'
import DockStateLoggedIn from '~/components/DockStateLoggedIn'
import DockStateLoggedOut from '~/components/DockStateLoggedOut'
import Flex from '~/components/Flex'
import Hud from '~/components/Hud'
import { useActions, useStore } from '~/store/hooks'
import { useWindowSize } from '~/utils/hooks'

const DOCK_HEIGHT = 48
const CENTER_MAGIC = 72

export default function Dock() {
  const user = useStore(actions => actions.account.user)
  const access = useStore(state => state.ref.access)
  const visibility = useStore(state => state.hud.visibility)
  const justification = useStore(state => state.hud.justification)
  const dragX = useStore(state => state.hud.dragX)
  const dragY = useStore(state => state.hud.dragY)
  const open = useStore(state => state.hud.toggles.open)

  const setVisibility = useActions(actions => actions.hud.setVisibility)
  const setDragX = useActions(actions => actions.hud.setDragX)
  const setDragY = useActions(actions => actions.hud.setDragY)

  const [yPosition, setYPosition] = useState(DOCK_HEIGHT)
  const { height } = useWindowSize()

  useEffect(() => {
    const shouldMinimize = !!ss.get('netlify-cdp-dock-minimized')
    const savedVisibility = shouldMinimize ? 'minimized' : 'showing'
    // @ts-ignore
    setVisibility(savedVisibility)
  }, [])

  useEffect(() => {
    setTimeout(() => {
      let y
      if (visibility === 'showing') {
        y = open ? window.innerHeight * -1 + CENTER_MAGIC : 0
      } else {
        y = DOCK_HEIGHT
      }
      setYPosition(y)
    }, 1)
  }, [visibility, open, height])

  const showDock = () => {
    const isLoading = access === 'LOADING'
    const isLoggedOut = !user.id
    const isOnTeam = !isLoggedOut && (access === 'APPROVED' || access === 'PENDING_APPROVAL')
    const isNotOnTeam = !isLoggedOut && access === 'UNAUTHORIZED'

    // return <DockStateLoggedOut />

    if (isLoading) {
      return <DockStateLoading />
    }

    if (isLoggedOut) {
      return <DockStateLoggedOut />
    }

    if (isOnTeam) {
      return <DockStateLoggedIn />
    }

    if (isNotOnTeam) {
      return <DockStateJoinTeam />
    }

    return <DockStateErrored />
  }

  return (
    <>
      <DockMinimized />
      <Flex
        aria-hidden={visibility !== 'showing'}
        bottom={0}
        className="dock"
        justifyContent={justification}
        marginX={16}
        position="fixed"
        transform={`translateY(${yPosition}px)`}
        transition="transform 500ms ease"
        width="calc(100% - 32px)"
      >
        <Draggable
          disabled={!open}
          handle=".drag-handle"
          onStop={(_, data) => {
            setDragX(data.x)
            setDragY(data.y)
          }}
          position={open ? { x: dragX, y: dragY } : { x: 0, y: 0 }}
        >
          <Pane
            background="tint1"
            borderTopLeftRadius={8}
            borderTopRightRadius={8}
            boxShadow="0 0 6px rgba(0, 0, 0, 0.2)"
            minWidth={768}
            zIndex={2147483647}
          >
            <Flex>{showDock()}</Flex>
            <Hud />
          </Pane>
        </Draggable>
      </Flex>
    </>
  )
}
